'use strict';
var novicell = novicell || {};

novicell.skipOnboarding = novicell.skipOnboarding || function () {

    function init() {
        skipOnboarding();
    }

    function skipOnboarding() {
        let pages = document.querySelectorAll('.wpforms-page');

        pages.forEach(page => {

            if ( !page.classList.contains('last') ) {
                let pagebreak = page.querySelector('.wpforms-field-pagebreak:last-child'); 
                let skipOnboardingElement = document.createElement('div');

                skipOnboardingElement.innerHTML = '<div class="card__link"><div class="card__link--skip-onboarding"><a href="/app/video">Start træning uden onboarding</a></div>';
                
                pagebreak.appendChild(skipOnboardingElement);

            }
            
        });
    }

    return {
        init : init,
        skipOnboarding : skipOnboarding
    };

}();